import { Loader2, Inbox, AlertCircle, RotateCw } from 'lucide-react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

export function Loading({ className, label }: { className?: string; label?: string }) {
  return (
    <div className={cn('flex items-center justify-center gap-2 py-16 text-muted-foreground', className)}>
      <Loader2 className="h-5 w-5 animate-spin" />
      {label && <span className="text-sm">{label}</span>}
    </div>
  )
}

export function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  action,
}: {
  icon?: typeof Inbox
  title: string
  description?: string
  action?: ReactNode
}) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
        <Icon className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="text-sm font-semibold">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}

/** Màn lỗi tải dữ liệu. Có `onRetry` → nút "Thử lại" (kèm `hint`, vd "Hệ thống sẽ tự thử lại…"). */
export function ErrorState({ message, hint, onRetry }: { message?: string; hint?: string; onRetry?: () => void }) {
  const { t } = useTranslation('sharedMisc')
  return (
    <div className="flex flex-col items-center justify-center px-4 py-16 text-center">
      <AlertCircle className="mb-2 h-8 w-8 text-destructive" />
      <p className="text-sm text-muted-foreground">{message || t('feedback.errorLoadingData')}</p>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-3 inline-flex items-center gap-1.5 rounded-md border px-3 py-1.5 text-sm hover:bg-muted"
        >
          <RotateCw className="h-3.5 w-3.5" /> {t('feedback.retry')}
        </button>
      )}
    </div>
  )
}
